import { mapMutations, mapState } from 'vuex'
import IcClose from '@/assets/svg/ic-close.svg?inline'

export default {
  name: 'CopyNotification',
  components: {
    IcClose
  },
  data() {
    return {
      isShowTimeout: null
    }
  },
  computed: {
    ...mapState({
      copied: state => state.notifications.copied
    })
  },
  beforeDestroy() {
    this.hide()
  },
  methods: {
    ...mapMutations({
      setCopied: 'notifications/SET_COPIED'
    }),
    clearShowTimeout() {
      clearTimeout(this.isShowTimeout)
      this.isShowTimeout = null
    },
    setShowTimeout() {
      this.clearShowTimeout()
      this.isShowTimeout = setTimeout(() => {
        this.setCopied('')
      }, 5000)
    },
    hide() {
      this.setCopied('')
      this.clearShowTimeout()
    }
  },
  watch: {
    copied() {
      if (this.copied) {
        this.setShowTimeout()
      }
    }
  }
}